import React, { useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import banner from "../assests/about.webp";
import banner2 from '../assests/Group 193.png';
import vision from "../assests/viss.png";
import mission from "../assests/mi.png";
import about1 from "../assests/about_detail (1).png";
import about2 from "../assests/about_detail (2).png";
import about3 from "../assests/about_detail (3).png";
import Newsletter from "../components/Newsletter";
import Banner from "../components/Banner";
import Banner2 from "../components/Banner2";
import { Link } from "react-router-dom";


const About = () => {
	const [openFAQ, setOpenFAQ] = useState(1);
	const toggleFAQ = (id) => {
		setOpenFAQ(openFAQ === id ? null : id);
	};
	const faqs = [
		{ id: 1, question: "Company Overview", answer: "Founded in 1992, Ultrapure Envirocare Pvt. Ltd. has grown into a trusted leader in air purification solutions. \n Driven by a commitment to improving indoor air quality, we leverage advanced technology and a tailored approach to deliver the purest air possible. \n Headquartered in Mumbai, we have a strong footprint across India and an expanding international presence. \n Connect with us to discover how we can help you create healthier, safer environments wherever you are. \n" },
		{ id: 2, question: "Our Team", answer: "At Ultrapure, our success is powered by our passionate and innovative team. Our in-house research and development experts are constantly working to deliver cutting-edge air purification technology. Get to know the specialists dedicated to ensuring you breathe the cleanest air possible. " },
		{ id: 3, question: "Global presence", answer: "Ultrapure is not only a leader in India but also making a global impact. Our top-tier air purification solutions are trusted around the world, ensuring cleaner air for all. Explore our international reach and see how we’re contributing to a healthier planet." },
		{ id: 4, question: "Sustainable Initiative", answer: "At Ultrapure, sustainability is central to our mission. We are dedicated to developing eco-friendly air purification solutions that safeguard both your health and the environment. Our decarbonization efforts are aimed at minimizing carbon emissions across our manufacturing processes and product lifecycle. \n \n Discover our sustainable practices and how we’re helping to create a greener planet." },
		{ id: 5, question: "Customer-Centric Approach ", answer: "At Ultrapure, excellence is at the core of everything we do. Whether it’s product design, manufacturing, or customer service, we prioritize our customers' needs and satisfaction above all else." }
		// Add more FAQs as needed
	];
	return (
		<div className="overflow-x-hidden">
			<div className="relative  text-white display_hide">

				{/* <img src={src} alt="Card image" className="w-full h-full object-cover opacity-100" /> */}
				<img src={banner} alt="banner" className="w-full h-full object-cover opacity-75" />
				<div className="absolute inset-0 flex items-center justify-center">
					<div className="p-8 text-center">
						<h1 className="text-3xl md:text-5xl lg:text-7xl font-bold text-gray-500">About Us</h1>
						<p className="mt-9 text-sm md:text-xl lg:text-xl w-3/4 text-center m-auto display_hide text-gray-500">Welcome to Ultrapure — your trusted partner in advanced air purification solutions. We are dedicated to transforming indoor environments by delivering cleaner, healthier air through innovation, reliability, and a commitment to well-being.</p>

					</div>
				</div>
			</div>
			<Banner2
				src={banner2}
				title="About Us"
				text="Welcome to Ultrapure, your trusted partner in cutting-edge air purification solutions, committed to enhancing indoor air quality for a healthier world."
				updated=""
				buttonUrl=""
				buttonText=""
			/>

			<section className="bg-[#fcfcfc] py-16 lg:py-24">
				<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
					<h2 className="text-4xl lg:text-5xl font-semibold mb-8 text-[#4c4c4c] max-w-4xl m-auto">
						Engineering Clean Air. Powering Better Environments.</h2>
					<p className="text-[20px] lg:text-[18px] text-[#8b8b8b] mb-8 max-w-6xl mx-auto">
						At Ultrapure, we specialize in cutting-edge air purification solutions tailored for high-performance sectors — including healthcare, pharmaceuticals, manufacturing, transportation, and public infrastructure. Our technologies are engineered to meet the highest standards, ensuring cleaner air and healthier spaces where it matters most.					
					</p>
				</div>
			</section>



			<section className="bg-white py-16 sm:py-20 lg:py-24">
				<div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">

					{/* Mission Section */}
					<div className="flex flex-col lg:flex-row items-center gap-8 sm:gap-12 lg:gap-16 mb-16 sm:mb-20 lg:mb-24">

						{/* Mission Image - Top on mobile, Right on desktop */}
						<div className="w-full sm:w-80 lg:w-96 flex-shrink-0 order-1 lg:order-2">
							<div className="flex items-center justify-center">
								<img
									src={mission}
									alt="Mission Icon"
									className="lg:w-[200px]  sm:max-w-sm lg:max-w-full object-contain"
								/>
							</div>
						</div>

						{/* Mission Text Content - Bottom on mobile, Left on desktop */}
						<div className="flex-1 text-center lg:text-left lg:pr-8 order-2 lg:order-1">
							<h2 className="text-3xl sm:text-4xl lg:text-5xl xl:text-4xl font-light text-[#8B8B8B] mb-6 sm:mb-8 lg:mb-10">
								Our Mission
							</h2>

							<p className="text-[#8B8B8B] text-base sm:text-lg lg:text-xl leading-relaxed font-light max-w-3xl mx-auto lg:mx-0">
								To create a world where every breath is clean, safe, and sustainable — by leading the innovation in air purification technology and empowering communities to thrive in healthier environments.							</p>
						</div>
					</div>

					{/* Vision Section */}
					<div className="flex flex-col lg:flex-row items-center gap-8 sm:gap-12 lg:gap-16">

						{/* Vision Image - Top on mobile, Left on desktop */}
						<div className="w-full sm:w-80 lg:w-96 flex-shrink-0 order-1">
							<div className="flex items-center justify-center">
								<img
									src={vision}
									alt="Vision Icon"
									className="lg:w-[200px]  sm:max-w-sm lg:max-w-full object-contain"
								/>
							</div>
						</div>

						{/* Vision Text Content - Bottom on mobile, Right on desktop */}
						<div className="flex-1 text-center lg:text-left lg:pl-8 order-2">
							<h2 className="text-3xl sm:text-4xl lg:text-5xl xl:text-4xl font-light text-[#8B8B8B] mb-6 sm:mb-8 lg:mb-10">
								Our Vision
							</h2>

							<p className="text-[#8B8B8B] text-base sm:text-lg lg:text-xl leading-relaxed font-light max-w-3xl mx-auto lg:mx-0">
								To improve the health and well-being of communities by delivering innovative, reliable, and sustainable air purification solutions as well as reducing carbon footprint. We are committed to creating cleaner indoor environments by removing harmful pollutants, allergens, and airborne contaminants—ensuring the air you breathe is always safe, fresh, and pure.
							</p>
						</div>
					</div>
				</div>
			</section>


			<section className="bg-[#F5F6F8] ">
				<div className=" mx-auto ">
					<div className="flex flex-col lg:flex-row items-start gap-8 lg:gap-16">

						{/* Left Section - Image */}
						<div className="flex-shrink-0 w-full lg:w-auto flex items-center justify-center lg:justify-start">
							{/* <div className="w-full max-w-md lg:max-w-none lg:w-80 xl:w-96"> */}
							<img
								src="./banner/about.png"
								alt="Business professionals in meeting"
								className="w-full h-auto rounded-lg shadow-lg object-cover"
							/>
							{/* </div> */}
						</div>

						{/* Right Section - Expandable Content */}
						<div className="flex-1 w-full">
							<div className="flex-1">
								<div class=" aboutbg  bg-cover bg-center">
									<div className=" p-6">
										{/* bg-gradient-to-r from-purple-400 via-pink-500 to-red-500 */}
										<div className="w-full lg:max-w-5xl mx-auto  p-2 lg:p-8 ">
											{faqs.map(faq => (
												<div key={faq.id} className="mb-4 z-40">
													<button
														className={`w-full text-left p-5  text-xl lg:text-2xl font-bold flex text-[#1C97D4] justify-between items-center focus:outline-none transition-colors duration-300 border-l-4 border-l-customBlue ${openFAQ === faq.id ? 'bg-gray-200 ' : ''}`}
														onClick={() => toggleFAQ(faq.id)}
													>
														<span className="text-lg">{faq.question}</span>
														{/* <FontAwesomeIcon icon={openFAQ === faq.id ? faChevronDown : faChevronRight} /> */}
													</button>
													{openFAQ === faq.id && (
														<div className=" p-4 border-l-4 border-l-customBlue text-[#0D1315] text-xs">
															{faq.answer}
														</div>
													)}
												</div>
											))}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>


			<div className="py-8 px-4">
				<div className="container mx-auto max-w-6xl mt-5">

					{/* Section 1: In-House Manufacturing */}
					<div className="mb-16">
						<div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
							{/* Text Content - Left */}
							<div className="w-full lg:w-3/5 order-2 lg:order-1">
								<div className="text-left">
									<h5 className="text-xl lg:text-4xl  font-bold  about_heading">
										In-House Manufacturing
									</h5>

									<div className="mb-8">
										<div className="mb-4">
											<h6 className="mini_text_head mb-3 mt-3 text-xl">
												Precision Engineering
											</h6>
										</div>
										<p className="mini_text text-left leading-relaxed text-base">
											Our skilled team of engineers and technicians meticulously
											craft each air purification system with precision and care,
											ensuring the highest quality standards
										</p>
									</div>

									<div className="mb-8">
										<div className="mb-4">
											<h6 className="mini_text_head mb-3 mt-3 text-xl">
												Quality Assurance
											</h6>
										</div>
										<p className="mini_text text-left leading-relaxed text-base">
											With our in-house manufacturing facilities, we maintain
											control over the entire production process, from raw
											materials to finished products, to deliver reliable and
											efficient solutions to our customers.
										</p>
									</div>
								</div>
							</div>

							{/* Image - Right */}
							<div className="w-full lg:w-2/5 order-1 lg:order-2">
								<div className="flex justify-center lg:justify-end">
									<img
										src={about1}
										alt="Manufacturing Facility"
										className="w-full max-w-md lg:max-w-full h-auto rounded-lg shadow-lg object-cover"
									/>
								</div>
							</div>
						</div>
					</div>

					{/* Section 2: Research & Development */}
					<div className="mb-16">
						<div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
							{/* Image - Left */}
							<div className="w-full lg:w-2/5 order-1">
								<div className="flex justify-center lg:justify-start">
									<img
										src={about2}
										alt="Research Laboratory"
										className="w-full max-w-md lg:max-w-full h-auto rounded-lg shadow-lg object-cover"
									/>
								</div>
							</div>

							{/* Text Content - Right */}
							<div className="w-full lg:w-3/5 order-2">
								<div className="text-left">
									<h5 className="text-xl lg:text-4xl  font-bold  about_heading">
										Research & Development
									</h5>

									<div className="mb-8">
										<div className="mb-4">
											<h6 className="mini_text_head mb-3 mt-3 text-xl">
												Pioneering Innovation
											</h6>
										</div>
										<p className="mini_text text-left leading-relaxed text-base">
											Our dedicated Research and Development (R&D) team works
											tirelessly to push the boundaries of air purification
											technology, seeking new and improved solutions to combat
											indoor air pollution.
										</p>
									</div>

									<div className="mb-8">
										<div className="mb-4">
											<h6 className="mini_text_head mb-3 mt-3 text-xl">
												Continuous Improvement
											</h6>
										</div>
										<p className="mini_text text-left leading-relaxed text-base">
											Through rigorous testing, experimentation, and collaboration
											with industry experts, we stay at the forefront of
											advancements in air quality management, driving innovation
											and progress.
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>

					{/* Section 3: Our Commitment */}
					<div className="mb-16">
						<div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
							{/* Text Content - Left */}
							<div className="w-full lg:w-3/5 order-2 lg:order-1">
								<div className="text-left">
									<h5 className="text-xl lg:text-4xl  font-bold  about_heading">
										Our Commitment
									</h5>

									<div className="mb-8">
										<div className="mb-4">
											<h6 className="mini_text_head mb-3 mt-3 text-xl">
												Customer-Centric Approach
											</h6>
										</div>
										<p className="mini_text text-left leading-relaxed text-base">
											At Ultrapure, we are committed to excellence in everything we do. From product design and manufacturing to customer service and support, we prioritize the needs and satisfaction of our customers.
										</p>
									</div>

									<div className="mb-8">
										<div className="mb-4">
											<h6 className="mini_text_head mb-3 mt-3 text-xl">
												Building Trust
											</h6>
										</div>
										<p className="mini_text text-left leading-relaxed text-base">
											We believe in building long-lasting relationships with our customers and partners, based on trust, transparency, and mutual respect. Your satisfaction is our top priority, and we are here to support you every step of the way.
										</p>
									</div>
								</div>
							</div>

							{/* Image - Right */}
							<div className="w-full lg:w-2/5 order-1 lg:order-2">
								<div className="flex justify-center lg:justify-end">
									<img
										src={about3}
										alt="Team Commitment"
										className="w-full max-w-md lg:max-w-full h-auto rounded-lg shadow-lg object-cover"
									/>
								</div>
							</div>
						</div>
					</div>

				</div>
			</div>


			<section className="bg-gray-50 py-12 lg:py-10">
				<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
					<div className="flex flex-col lg:flex-row min-h-[400px]">

						{/* Right Section - Need Assistance (First on mobile, Right on desktop) */}
						<div className="w-full lg:w-1/2 flex items-center justify-center p-2 lg:p-12 order-1 lg:order-2">
							<div className="max-w-lg text-center lg:text-left">

								{/* Title */}
								<h2 className="text-3xl lg:text-5xl font-normal text-gray-800 mb-6 lg:mb-8">
									Need Assistance?
								</h2>

								{/* Description */}
								<p className="text-gray-500 text-base lg:text-lg leading-relaxed mb-8 lg:mb-10 font-thin">
									Whether you're exploring clean air solutions or need support for an existing installation, our team is here to help. Let's create a healthier environment—together.
								</p>

								{/* Support Button */}
								<Link to="/contact">
									<button className="bg-[#1C97D4] hover:bg-blue-600 text-white font-semibold px-10 py-3 rounded-lg text-base lg:text-lg transition-all duration-300 transform hover:scale-105 hover:shadow-xl shadow-lg">
										SUPPORT
									</button>
								</Link>
							</div>
						</div>

						{/* Left Section - Contact Info (Second on mobile, Left on desktop) */}
						<div className="w-full lg:w-1/2 flex items-center justify-center p-4 lg:p-12 order-2 lg:order-1">
							<div className="flex flex-col space-y-6 text-center lg:text-left w-full max-w-md">

								{/* Phone */}
								<div className="flex items-center justify-center lg:justify-start space-x-3">
									<img src="./phone-call 1.svg" width={25} alt="Phone Icon" />
									<div className="flex flex-col sm:flex-row sm:items-center sm:space-x-2">
										<a
											href="tel:1800110050"
											className="text-base sm:text-xl lg:text-2xl text-gray-800 font-medium hover:underline"
										>
											1800-1100-50
										</a>
										<span className="text-gray-500 text-sm sm:text-base lg:text-lg">(Toll Free)</span>
									</div>
								</div>

								{/* Email */}
								<div className="flex items-center justify-center lg:justify-start space-x-3">
									<img src="./mail 1.svg" width={25} alt="Mail Icon" />
									<a
										href="mailto:info@ultrapureindia.in"
										className="text-base sm:text-xl lg:text-2xl text-gray-800 font-medium break-words hover:underline"
									>
										info@ultrapureindia.in
									</a>
								</div>

							</div>
						</div>

					</div>
				</div>
			</section>
		</div>
	);
};

export default About;
